import {
  RATE_CREATE,
  RATE_UPDATE,
  RATE_DELETE,
  RATE_UPDATE_SUCCESS,
  RATE_CREATE_SUCCESS,
  RATE_DELETE_SUCCESS,
  RATE_LIST,
  RATE_LIST_SUCCESS,
  RATE_REQUEST_FAILED,
  RATE_FILTER,
} from "store/rates/actionTypes";

export const rateList = () => {
  return {
    type: RATE_LIST,
    payload: {},
  };
};

export const rateCreate = (rate) => {
  return {
    type: RATE_CREATE,
    payload: rate,
  };
};

export const rateUpdate = (id, data) => {
  return {
    type: RATE_UPDATE,
    payload: { id, data },
  };
};

export const rateDelete = (id) => {
  return {
    type: RATE_DELETE,
    payload: id,
  }
}

export const rateListSuccess = (rates) => {
  return {
    type: RATE_LIST_SUCCESS,
    payload: rates,
  };
};

export const rateCreateSuccess = (rateCreated) => {
  return {
    type: RATE_CREATE_SUCCESS,
    payload: rateCreated,
  };
};

export const rateFilter = (changeUrl) => {
  return {
    type: RATE_FILTER,
    payload: { changeUrl },
  };
};

export const rateUpdateSuccess = (rate) => {
  return {
    type: RATE_UPDATE_SUCCESS,
    payload: rate,
  };
};

export const rateDeleteSuccess = () => {
  return {
    type: RATE_DELETE_SUCCESS,
    payload: {},
  };
};

export const rateRequestFailed = (error) => {
  return {
    type: RATE_REQUEST_FAILED,
    payload: error,
  };
};
